

const data = {
  p1: {
    title: "数字员工企业版",
    subtitle: "AI创作零门槛，轻松打造品牌内容生态矩阵",
    link: "https://aibeings-vip.xiaoice.com/",
  },
  p2: {
    title: "数字员工平台基于AI多模态引擎技术",
    subtitle: "重构IP内容生产及传播新范式",
    desc: [
      "融合高精度数字形象与高拟真声音复刻技术的数字员工定制及视频生产能力，可协助用户大幅提升IP内容生产效率，无需依赖专业拍摄团队与复杂后期，快速填充多平台内容池",
      "对接多平台构建内容矩阵，支持定制、生产、分发全链路自动化与规模化的内容产出，减少运营人力投入，聚焦创意优化，让IP运营更轻量",
      "助力企业及个人IP持续稳定的输出符合品牌调性的专业内容（如企业数字高管解读动态资讯、行业数字KOL分享垂直领域知识等），吸引精准受众，沉淀品牌资产，扩大传播影响力"
    ],
    imgs: ["p2Img1", "p2Img2"], // 仅存图片key，页面import后传入
  },
  p3: {
    title: "产品优势",
    list: [
      {
        anchor: "极速复制",
        desc: "极速复刻人物形象与声音，10秒即可完成从采集到定制全流程",
        img: "p3Img1",
        icon: "P3Icon1"
      },
      {
        anchor: "AI智能成片",
        desc: "AI自动学习爆款文案，智能剪辑一键成片，轻松打造精品视频",
        img: "p3Img2",
        icon: "P3Icon2"
      },
      {
        anchor: "内容矩阵",
        desc: "一键替换多形象，自动分发各平台，快速生产矩阵化内容，实现高效裂变",
        img: "p3Img3",
        icon: "P3Icon3"
      }
    ]
  },
  p4: {
    title: "全面解决营销矩阵生态打造难题",
    highlight: "营销矩阵生态",
    img: "P4Img1"
  }
};

export default data;